import { createApp } from "vue";
import SingleProductCombinations from "../../components/ProductBlock/SingleProductCombinations.vue";
import i18n from "../translations/i18n";

export const initializeSingleProductCombinations = () => {
    if (!document.getElementById('js_product_single')) {
        return;
    }

    createApp({
        components: {
            SingleProductCombinations
        }
    })
        .use(i18n)
        .mount('#js_product_single');
};